// Plays a short, pleasant two-note "ping" using the Web Audio API so we don't
// need to ship an audio asset. Safe to call repeatedly; it lazily creates a
// single shared AudioContext and resumes it (browsers start it suspended until
// a user gesture, which has normally happened by the time notifications fire).

let ctx = null;

function getContext() {
  if (ctx) return ctx;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  ctx = new AudioCtx();
  return ctx;
}

export function playPing() {
  try {
    const audio = getContext();
    if (!audio) return;
    if (audio.state === "suspended") audio.resume();

    const now = audio.currentTime;
    // Two quick ascending notes.
    [
      { freq: 880, start: 0, dur: 0.12 },
      { freq: 1320, start: 0.1, dur: 0.16 },
    ].forEach(({ freq, start, dur }) => {
      const osc = audio.createOscillator();
      const gain = audio.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(0.18, now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(gain).connect(audio.destination);
      osc.start(now + start);
      osc.stop(now + start + dur + 0.02);
    });
  } catch (_) {
    /* audio unavailable — fail silently */
  }
}
